export const getMonthShortName = (month) => {
    switch (month) {
        case 0:
            return 'Jan';
        case 1:
            return 'Feb';
        case 2:
            return 'Mar';
        case 3:
            return 'Apr';
        case 4:
            return 'May';
        case 5:
            return 'Jun';
        case 6:
            return 'Jul';
        case 7:
            return 'Aug';
        case 8:
            return 'Sep';
        case 9:
            return 'Oct';
        case 10:
            return 'Nov';
        case 11:
            return 'Dec';
        default:
    }
};

export const padZero = (value) => {
    if (String(value).length === 1) {
        return '0' + String(value);
    }

    return String(value);
};

export const getDateTimeDisplay = (curDate) => {
    const dateTimeDisplay = curDate.getDate() + ' ' + getMonthShortName(curDate.getMonth()) + ' ' + curDate.getFullYear() + ' ' + curDate.getHours() + ':' + padZero(curDate.getMinutes());
    return dateTimeDisplay;
};

export const getDateTimeWithSecDisplay = (curDate) => {
    const dateTimeDisplay = curDate.getDate() + ' ' + getMonthShortName(curDate.getMonth()) + ' ' + curDate.getFullYear() + ' ' + curDate.getHours() + ':' + padZero(curDate.getMinutes()) + ':' + padZero(curDate.getSeconds());
    return dateTimeDisplay;
};

export const getSqlDateByDatePicker = (datePicker) => {
    const sqlDate = datePicker.$y + '-' + padZero(datePicker.$M + 1) + '-' + padZero(datePicker.$D);
    return sqlDate;
}

export const getSqlDateTimeByDateTimePicker = (dateTimePicker) => {
    const sqlDate = dateTimePicker.$y + '-' + padZero(dateTimePicker.$M + 1) + '-' + padZero(dateTimePicker.$D) + ' ' + padZero(dateTimePicker.$H) + ':' + padZero(dateTimePicker.$m) + ':' + padZero(dateTimePicker.$s);
    return sqlDate;
}

export const getSqlDate = (curDate) => {
    const dateDisplay = curDate.getFullYear() + '-' + padZero(curDate.getMonth() + 1) + '-' + padZero(curDate.getDate());
    return dateDisplay;
};

export const getStartOfMonth = (curDate) => {
    return new Date(curDate.getFullYear(), curDate.getMonth(), 1);
}

export const getEndOfMonth = (curDate) => {
    return new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0);
}
